// extracted by mini-css-extract-plugin
export default {"inline-code":"inline-code--c8d0bd","inlineCode":"inline-code--c8d0bd","inline-code_tiny":"inline-code_tiny--a41f10","inlineCode_tiny":"inline-code_tiny--a41f10"};